import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { getCurrentOrganization, type MemberResponse } from '@api/organizations';
import useAuth from '@contexts/useAuth';

const ORG_MEMBERS_KEY = ['organization', 'members'] as const;

/**
 * React Query wrapper that fetches the current org's member list.
 * Used by the ReviewerPicker to populate the people-picker dropdown.
 * Cached for 60 s so switching between gate nodes doesn't re-fetch.
 */
export function useOrgMembers(): UseQueryResult<MemberResponse[], Error> {
  const { user } = useAuth();
  const token = user?.token;
  const userId = user?.id;

  return useQuery<MemberResponse[], Error>({
    queryKey: [...ORG_MEMBERS_KEY, userId],
    queryFn: async () => {
      if (!token) throw new Error('Not authenticated');
      const data = await getCurrentOrganization(token);
      return data.members;
    },
    enabled: Boolean(token),
    staleTime: 60_000,
    retry: 1,
  });
}
